import { useEffect, useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { database } from "../services/firebase";

export type PesquisaType = {
    authorId: string;
    avatar: string;
    nome: string;
    cpf: string;
    telefone: string;
    presencial: boolean;
    respondidoEm: string;
    removidoPor: string;
};
export type ModuloType = {
    id: string;
    nome: string;
    turma: string;
    professor: string;
    auditorio: string;
    capacidade: string;
    dataAberturaPesquisa: string;
    dataFechamentoPesquisa: string;
    dataAula1: string;
    dataAula2: string;
    dataAula3: string;
    dataAula4: string;
    pesquisas: Array<PesquisaType>;
    alunos: PesquisaType[];
};

export type Professor = {
    authorId: string;
    cpf: string;
    hidden: boolean;
    id: string;
    nome: string;
};

export type Aluno = {
    authorId: string;
    cpf: string;
    id: string;
    nome: string;
};

export function useModulos(restrict?: boolean): ModuloType[] {
    const { user } = useAuth();
    const [modulos, setModulos] = useState<ModuloType[]>([]);

    useEffect(() => {
        if (user === undefined) {
            return;
        }

        const modulosRef = database.ref("modulos");

        modulosRef.orderByChild("nome").once("value", (snapshot) => {
            let parsedValues: ModuloType[] = [];

            snapshot.forEach((instance) => {
                console.log("snapshot modulos");
                let modulo: ModuloType = instance.val();
                modulo.id = instance.key || "";
                if (modulo.pesquisas) {
                    let qtdPesquisas = Object.values(modulo.pesquisas || {}).length;
                }
                //if () {
                //hasLiked: Object.values(value.likes ?? {}).some(like => like.authorId === user?.id),
                //likeId: Object.entries(value.likes ?? {}).find(([key, like]) => like.authorId === user?.id)?.[0],
                //}
                if (user) {
                    let participa = Object.values(modulo.pesquisas ?? {}).some((resposta) => resposta.authorId === user?.id);
                    //console.log("userid:" + user?.id);
                    //console.log(modulo.pesquisas);
                    //console.log("participa:" + participa);
                    Object.values(modulo.pesquisas || {}).every((resposta) => {
                        if (!modulo.alunos) {
                            modulo.alunos = [];
                        }
                        modulo.alunos.push(resposta);
                        return "";
                    });
                    if (participa && restrict) parsedValues.push(modulo);
                }
                if (!restrict) {
                    parsedValues.push(modulo);
                }
            });
            setModulos(parsedValues);
        });
    }, [user?.id]);

    return modulos;
}
